import angular from 'angular';

angular.module('cloudX').directive('cxConfigValidator', [
  function() {
    return {
      restrict: 'E',
      template: require('./configValidator.html'),
      replace: true,
      scope: {
        validator: '=',
        fields: '=',
        fieldType: '@',
        fieldId: '@',
        idx: '@',
        remove: '&delete',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.validatorType = -1;
          $scope.fields = $scope.fields.filter(function(el) {
            return '' + el.type === '' + $scope.fieldType && el.id !== $scope.fieldId;
          });

          function getType(value) {
            if (isGuid(value)) return 1;
            if (
              $scope.validatorType === 2 &&
              typeof value === 'string' &&
              value.toUpperCase() === 'TODAY'
            )
              return 2;

            return 0;
          }

          switch ($scope.fieldType) {
            case '1':
              $scope.validatorType = 1;
              $scope.numStep = 1;
              break;
            case '2':
            case '41':
              $scope.validatorType = 1;
              $scope.numStep = 0.01;
              break;
            case '3':
              $scope.dateMin = {
                today: $scope.validator.minimum === 'TODAY',
                opened: false,
              };
              $scope.dateMax = {
                today: $scope.validator.maximum === 'TODAY',
                opened: false,
              };
              if (
                typeof $scope.validator.minimum === 'string' &&
                $scope.validator.minimum !== 'TODAY' &&
                !isGuid($scope.validator.minimum)
              )
                $scope.validator.minimum = Date.parse($scope.validator.minimum);
              if (
                typeof $scope.validator.maximum === 'string' &&
                $scope.validator.maximum !== 'TODAY' &&
                !isGuid($scope.validator.maximum)
              )
                $scope.validator.maximum = Date.parse($scope.validator.maximum);
              $scope.validatorType = 2;
              break;
            case '5':
              $scope.maxStringLength = 25;
              $scope.validatorType = 3;
              break;
            case '6':
              $scope.maxStringLength = 100;
              $scope.validatorType = 3;
              break;
            case '7':
            case '37':
            case '38':
            case '44':
              $scope.maxStringLength = 255;
              $scope.validatorType = 3;
              break;
            case '8':
            case '86':
              $scope.maxStringLength = undefined;
              $scope.validatorType = 3;
              break;
          }

          $scope.show = {
            country: $scope.validator.country != null,
            minimum: $scope.validator.minimum != null,
            maximum: $scope.validator.maximum != null,
            regularExpression: $scope.validator.regularExpression != null,

            minimumType: getType($scope.validator.minimum),
            maximumType: getType($scope.validator.maximum),
          };

          $scope.validator.type = $scope.validatorType;

          $scope.toggle = function(prop) {
            if (!$scope.show[prop]) $scope.validator[prop] = null;
          };
        },
      ],
    };
  },
]);
